import { render, staticRenderFns } from "./StaticLabel.vue?vue&type=template&id=22d561bf&"
import script from "./StaticLabel.vue?vue&type=script&lang=ts&"
export * from "./StaticLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports